import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';

export namespace NStockCmsConfig {
    export const ID = 'stock_config';

    export interface IData extends IConfigData {
        messages: IMessage[];
    }

    export interface IMessage {
        code: string;
        label: string;
        stockTrayLabel?: string;
    }

    export interface IConfig extends ICmsConfig<IData> {}
}

ICmsContentService.registerConfig({
    id: NStockCmsConfig.ID,
    name: 'Stock configuration',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'messages',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Messages',
            defaultSize: 0,
            itemNameField: 'code',
            fields: [
                {
                    key: 'code',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Code',
                    required: true
                },
                {
                    key: 'label',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Label',
                    required: true
                },
                {
                    key: 'stockTrayLabel',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Stock tray label',
                    description: 'This label will be displayed in the stock tray, if empty the label will be displayed'
                }
            ]
        }
    ]
});
